<template>
	<div class="hidden-md-and-down app-top-bar__right-menu">
		<div class="app-top-bar__name mr-2">
			{{ this.profile.visible_username }}
		</div>
		<v-list-item-group
			class="hidden-sm-and-down d-flex"
			active-class="app-top-bar__navigation-active"
			v-ripple="true"
			link
		>
			<v-menu
				left
				close-on-click
				offset-y
				content-class="app-top-bar__profile-menu elevation-0"
			>
				<template v-slot:activator="{ on }">
					<v-btn
						class="app-top-bar__avatar-btn"
						:class="[opacity ? 'app-top-bar__menu-opacity' : '']"
						icon
						x-large
						v-on="on"
					>
						<v-avatar class="app-top-bar__profile-avatar" size="40">
							<img
								v-if="userAvatar"
								referrerpolicy="no-referrer"
								:src="userAvatar"
								alt="avatar"
							/>
							<v-icon v-else size="41" dark> mdi-account-circle </v-icon>
						</v-avatar>
					</v-btn>
				</template>
				<v-card tile class="elevation-0">
					<v-list-item-content class="justify-center pa-3">
						<v-list-item
							active-class="app-top-bar__active-profile"
							class="app-top-bar__profile-card-item"
							v-for="(setting, index) in profileSettings"
							:key="index"
							@click="setting.action"
							link
							:to="setting.path"
						>
							<img :src="setting.icon" alt="none" class="mr-2" />
							{{ setting.name }}
						</v-list-item>
					</v-list-item-content>
				</v-card>
			</v-menu>
		</v-list-item-group>
	</div>
</template>

<script>
import magnifyIcon from '@/assets/images/search.svg'
import { mapGetters } from 'vuex'

export default {
	name: 'Menu',
	data() {
		return {
			magnifyIconSrc: magnifyIcon,
			searchValue: '',
			expandSearch: false,
			opacity: false,
			avatar: 'https://e7.pngegg.com/pngimages/799/987/png-clipart-computer-icons-avatar-icon-design-avatar-heroes-computer-wallpaper-thumbnail.png',
		}
	},
	watch: {
		$route() {
			this.opacity = this.opacityRoutes.includes(this.$route.name)
		},
	},
	props: {
		opacityRoutes: {
			type: Array,
			default: () => [],
		},
		isAuth: {
			type: Boolean,
			default: false,
		},
		profileSettings: {
			type: Array,
			default: () => [],
		},
		categories: {
			type: Array,
			default: () => [],
		},
		navigation: {
			type: Array,
			default: () => [],
		},
		userAvatar: {
			type: String,
			default: null,
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
	},
	methods: {
		searchHandler() {
			this.$eventBus.$emit('search', this.searchValue)
		},
	},
}
</script>

<style lang="scss">
.app-top-bar {
	&__menu-opacity {
		opacity: 0.5;
	}
	&__search-icon {
		cursor: pointer;
	}
	&__name {
		color: rgb(255, 255, 255);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}
}
.menu {
	display: flex;
	justify-content: flex-end;
	width: 300px;

	.theme--light.v-list-item:hover::before {
		opacity: 0;
	}

	.theme--light.v-btn:hover::before {
		opacity: 0;
	}

	.v-ripple__container {
		opacity: 0;
	}
}
</style>
